import styled from 'styled-components';

export const HeroImg = styled.div`
  width: 100%;
  position: relative;
  &:before {
    content: '';
    padding-bottom: 53.33333333%;
    background-image: linear-gradient(
        to bottom left,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.47)
      ),
      url(${({ src }) => src});
    background-size: cover;
    display: block;
  }

  p {
    position: absolute;
    bottom: 0;
    color: #fff;
    padding: 0 0 10px 20px;
    font-size: 8vw;
    font-weight: 300;

    @media (min-width: 800px) {
      font-size: 64px;
    }
  }
`;
